export const typesOrder = {
    GET_ORDER_SUCCESS:'GET_ORDER_SUCCESS',
    GET_ORDER_ERROR:'GET_ORDER_ERROR',
    GET_ORDER_BEGIN:'GET_ORDER_BEGIN'
}
